<template>
  <div>
    <v-card-title>
      <v-flex xs3 class="mx-4">
        <v-select
          :items="attendeeMessages"
          v-model="filterByMessageType"
          @input="getDataMessages"
          label="Category Filter"
          item-text="Name"
          item-value="Id"
          clearable
        />
      </v-flex>
    </v-card-title>
    <v-data-table
      v-if="loadTable"
      :headers="headers"
      :items="orderedMessages"
      class="elevation-1"
      :pagination.sync="pagination"
      :total-items="getAllMessagesTotalItems"
      :loading="loading"
      :disable-initial-sort="true"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs">{{ getDate(props.item.submitDate) || getDate(props.item.sendDate)}}</td>
          <td class="text-xs">
            {{ checkEmail(props.item) }}
          </td>
          <td class="text-xs">{{ checkReceiverEmail(props.item) }}</td>
          <td class="text-xs">
            {{ checkFirstName(props.item) }}
          </td>
          <td class="text-xs">
            {{ checkLastName(props.item) }}
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                fab flat
                slot="activator"
                @click.stop="openModal('MessageModal', props.item)"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <span>Watch Message</span>
            </v-tooltip>
          </td>
          <td class="text-xs">{{ props.item.messageType }}</td>
        </tr>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
    <modal-attendee
      v-if="hasModal.MessageModal"
      :isShow="hasModal.MessageModal"
      :payload="payload"
      @close="closeModal('MessageModal')"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { attendeeMessages } from '@/modules/settings/'
  import { equals } from 'ramda'
  import mixins from '@/utils/mixins'
  import modalAttendee from './modalAttendee'

  export default {
    name: 'AttendeeMessages',
    mixins: [mixins.isWriteAvailable],
    components: {
      modalAttendee
    },
    data () {
      return {
        attendeeMessages,
        filterByMessageType: null,
        loadTable: false,
        loading: true,
        hasModal: {
          MessageModal: false
        },
        payload: null,
        pagination: {
          page: 1,
          rowsPerPage: 10
        },
        headers: [
          { text: 'Submit Date', value: 'SubmitDate', search: true, sortable: true, width: 150 },
          { text: 'Email', value: 'Email', sortable: false, width: 250 },
          { text: 'Receiver Email', value: 'ReceiverEmail', search: true, sortable: true, width: 250 },
          { text: 'First Name', value: 'FirstName', search: false, sortable: false, width: 150 },
          { text: 'Last Name', value: 'LastName', search: false, sortable: false, width: 150 },
          { text: 'Message Info', search: false, sortable: false, align: 'center', width: 100 },
          { text: 'Message Type', value: 'MessageType', search: true, sortable: true, width: 200 }
        ]
      }
    },
    computed: {
      ...mapGetters([
        'getMessages',
        'getAllMessagesTotalItems',
        'getAllMessagesTotalPages'
      ]),
      orderedMessages () {
        return this.getMessages.reverse()
      }
    },
    watch: {
      pagination: {
        handler (val, oldVal) {
          if (val.totalItems !== oldVal.totalItems) return
          this.getDataMessages()
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'fetchMessages'
      ]),
      sortingDirection (dir) {
        return dir ? 'Desc' : 'Asc'
      },
      async getDataMessages () {
        this.loading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const sorted = !!sortBy ? sortBy : null
        const sorter = {
          direction: this.sortingDirection(descending),
          sortBy: sorted
        }
        const equalsMessageType = {
          status: this.filterByMessageType,
          filterBy: 'MessageType'
        }
        const getParams = {
          page: pageCheck,
          itemsOnPage: equals(rowsPerPage, -1) ? this.getAllMessagesTotalItems : rowsPerPage,
          sorter,
          equalsMessageType
        }
        try {
          await this.fetchMessages(getParams)
          this.loadTable = true
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      getDate (date) {
        if (!date) return
        const d = new Date(date)
        const month = d.getMonth() + 1
        const day = d.getDate()
        const year = d.getUTCFullYear()
        return `${month} / ${day} / ${year}` === '1 / 1 / 0' ? 'No date' : `${month} / ${day} / ${year}`
      },
      checkEmail (item) {
        return item.senderEmail || item.email
      },
      checkReceiverEmail (item) {
        return item.receiverEmail || 'Contact us'
      },
      checkFirstName (item) {
        return item.senderFirstName || item.firstName
      },
      checkLastName (item) {
        return item.senderLastName || item.lastName
      },
      openModal (typeOfAction, item) {
        this.hasModal[typeOfAction] = true
        this.payload = item
      },
      closeModal (typeOfAction) {
        this.hasModal[typeOfAction] = false
      }
    },
    beforeMount () {
      this.getDataMessages()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/AttendeesMessages/index.vue